import AbstractAction from "../AbstractAction";

export default class AddPolyCoordinateAction extends AbstractAction {
    constructor(provider, element, potentialCoordinate) {
        super(provider);

        this.element = element;
        this.index = potentialCoordinate.index;

        this.newCoord = this.element.insertCoordinate(this.index, potentialCoordinate.absX, potentialCoordinate.absY);
    }

    update() {
        let moveX = (this.p.movedX || (this.p.mouseX - this.p.pmouseX)) / this.view.scale;
        let moveY = (this.p.movedY || (this.p.mouseY - this.p.pmouseY)) / this.view.scale;

        this.newCoord.move(moveX, moveY);
    }

    finish() {
        this.savedAbsX = this.newCoord.absX;
        this.savedAbsY = this.newCoord.absY;
        super.finish();
    }

    undo() {
        this.element.removeCoordinate(this.index);
    }

    redo() {
        this.element.insertCoordinate(this.index, this.savedAbsX, this.savedAbsY);
    }
}
